<template>
    <div class="join-us">
      <el-col :span="24" :xs="24" :sm="24" :md="20" :lg="20" :xl="20" class="join-us-box">
            <el-col 
              v-for="(news_item, index) in news_list" :key="index" class="join-us-item-box">
              <!-- <div style="width: 100%; height: auto" > -->
                <el-col :span="6" class="newsitem-title-pic">
                  <el-row class="title-item p-t8">
                    <b>{{news_item.title}}</b>
                  </el-row>
                  <el-row class="title-item p-t8">
                    ({{index+1}}人)
                  </el-row>
                </el-col>
                <el-col :span="18" class="newsitem-title-box">
                  <el-row class="title-item p-t8">
                    <b>{{news_item.title}}</b>
                  </el-row>
                  <el-row class="title-item ">
                    {{news_item.requirements}}</el-row>
                  <el-row class="title-item-detail">
                    {{news_item.require_detail}}</el-row>
                  <el-row class="title-item ">
                    {{news_item.Responsibilities}}</el-row>
                  <el-row class="title-item-detail">
                    {{news_item.Respons_detail}}</el-row>
                </el-col>
              <!-- </div> -->
            </el-col>

      </el-col>
    </div>
</template>
<script>
export default {
  name: "join-us",
  data() {
    return {
      news_list:[
        {title:'软件开发工程师（项目负责人）',
        requirements:'岗位要求:',
        require_detail:`1、计算机软件、电子、计算机、通信、自动化等相关专业, 2年以上工作经验；
                  2、熟悉MySQL，Redis的操作与原理；
                  3、熟练掌握Python语言；
                  4、熟悉Nginx配置及工作原理；
                  5、有较强的学习能力，对技术有钻研精神，并有较高的热情，有良好的口头和书面表达能力；
                  6、有项目开发、管理经验（医疗信息化项目优先）`,
        Responsibilities:'岗位职责:',
        Respons_detail:`1、负责相关系统的前后端系统开发；
                  2、负责相关技术方案设计与实现；
                  3、有Flask相关开发经验者优先`,
        pic_url:require('./images/2022-6.png'),
        },{
        title:'前端开发工程师(Vue.js)',
        requirements:'岗位要求:',
        require_detail:`1、负责产品前端架构与开发工作；
            2、参与前端基础工具及框架的设计与实现；
            3、对具体的产品进行性能优化，尝试更快更灵活的Webview新功能或体验优化，实现最优的页面加载、执行和渲染时间；
            4、配合后台工程师一起研讨技术实现方案，进行应用及系统的优化及整合；
            5、关注前端前沿技术研究，通过新技术服务团队和业务；`,
        Responsibilities:'岗位职责:',
        Respons_detail:`1、1年以上WEB APP开发经验或者3年以上网站前端开发经验；
            2、掌握Javascript、HTML/HTML5/XML、CSS/CSS3、Ajax等前端开发技术，熟悉W3C标准，深刻理解各主流浏览器之间的兼容性；
            3、熟练VUE技术，掌握Jquery, Bootstrap, Zepto等开发架构和框架，可以完成DOM处理、Ajax和事件处理，能快速高效实现各种动画交互效果；
            4、熟悉wibkit 、手机浏览器适配和基于系统webview的浏览器相关优化；
            5、熟悉http/xml/json/webservices等网络通信技术；
            6、对网站及页面性能优化有一定认识和经验；
            7、有医疗行业类业务前端开发经验者优先。`,
        pic_url:require('./images/2022-6.png'),
        },{
        title:'后端开发工程师(Python)',
        requirements:'岗位要求:',
        require_detail:`1、计算机软件、电子、计算机、通信、自动化等相关专业。2年以上工作经验；
            2、熟悉MySQL，Redis的操作与原理；
            3、熟练掌握Python语言；
            4、熟悉Nginx配置及工作原理；
            5、有较强的学习能力，对技术有钻研精神，并有较高的热情，有良好的口头和书面表达能力；`,
        Responsibilities:'岗位职责:',
        Respons_detail:`1、负责医疗相关系统的后台Web服务开发；
            2、负责相关技术方案设计与实现；
            3、熟悉python后端技术，有Flask相关开发经验者优先。
            4、有医疗行业类业务前端开发经验者优先。`,
        pic_url:require('./images/2022-6.png'),
        }
      ]};  
  },
  mounted() {
  },
  methods: {
  },
};
</script>
<style>
.join-us {
    background: var(--WhiteColor-1);
    height: 100%;
    margin-top: 8px;
    font-size: 14px;
    justify-content: center;
    display: flex;
  overflow: auto;
}
.join-us .join-us-box {
    /* width: 100%; */
    height: 100%;
  color: var(--BlackColor-1);
}
.join-us .join-us-box .join-us-item-box {
  display: flex;
  align-items: center;
  min-height: 33%;
  padding: 8px;
}
.join-us .join-us-box .join-us-item-box:hover {
  background: var(--SecondColor-10);
}
.join-us-item-box .newsitem-title-pic {
  overflow: hidden;
}
.join-us-item-box .newsitem-title-box {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 8px 16px;
  overflow: hidden;
  line-height: 140%;
  height: 100%;
}
.join-us-item-box .newsitem-title-box .title-item {
  white-space: nowrap;
  overflow: hidden;
  /* height: 20%; */
}
.join-us-item-box .newsitem-title-box .title-item-detail {
  /* height: 60%; */
  text-align:left;
  white-space: normal;
  text-overflow: ellipsis;
  overflow: hidden;
}

</style>